/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '@clerk/clerk-react';
import AccessDenied from '../../views/auth/AccessDenied';
import useAppAuth from '../../hooks/useAuth';
import { hasAnonymousSession } from '../../utils/anonymousSession';

const UserGuard = ({ children }) => {
  // const { isAuthenticated, user } = useAuth();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const navigate = useNavigate()
  const { isSignedIn, isLoaded } = useAuth();
  const { accessDenied } = useAppAuth();
  const location = useLocation();
  const guestChat = location.pathname === '/user/chat' && hasAnonymousSession();

  // let localAuthentication = localStorage.getItem('isAuthenticated')
  // let token = localStorage.getItem('token')



  useEffect(() => {
    // const getmyData = async () => {
    //   try {
    //     setLoading(true)
    //     let response = await ME();
    //     console.log('response', response)
    //     if (response?.status === 200) {
    //       localStorage.setItem('isAuthenticated', true)
    //       dispatch(setAuthUserState({
    //         isAuthenticated: "authenticated",
    //         isInitialized: true,
    //         user: response?.data?.data,
    //       }))
    //       setLoading(false)
    //     }
    //     if (response && response?.status === 401) {
    //       navigate('/login')
    //       setLoading(false)
    //     } else if (response && response?.status === 422) {
    //       setLoading(false)
    //       navigate('/login')
    //     }

    //   } catch (err) {
    //     console.log("Inside catch block login: ---", err);
    //     setLoading(false)
    //     navigate('/login')
    //   }
    // }
    // getmyData()
  }, [])
  if (!isLoaded) {
    return null;
  }
  if (accessDenied) {
    return <AccessDenied />;
  }
  if (!isSignedIn && !guestChat) {
    return <Navigate to="/login" />;
  }
  return (
    <>
      {children}
    </>
  );
};

UserGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserGuard;
